import { useEffect, useRef } from "react";

const SRC = "https://assets.calendly.com/assets/external/widget.js";
const CSS = "https://assets.calendly.com/assets/external/widget.css";

function ensureCalendly() {
  if (!document.querySelector(`link[href="${CSS}"]`)) {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = CSS;
    document.head.appendChild(l);
  }
  if (!document.querySelector(`script[src="${SRC}"]`)) {
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    document.body.appendChild(s);
  }
}

export function openCalendly(url) {
  ensureCalendly();
  const tryOpen = () => {
    if (window.Calendly) window.Calendly.initPopupWidget({ url });
    else setTimeout(tryOpen, 200);
  };
  tryOpen();
}

export function CalendlyInline({ url, height = 700 }) {
  const ref = useRef(null);
  useEffect(() => {
    ensureCalendly();
    let cancelled = false;
    const init = () => {
      if (cancelled) return;
      if (window.Calendly && ref.current) {
        ref.current.innerHTML = "";
        window.Calendly.initInlineWidget({ url, parentElement: ref.current });
      } else {
        setTimeout(init, 200);
      }
    };
    init();
    return () => {
      cancelled = true;
    };
  }, [url]);
  return <div ref={ref} style={{ minWidth: "320px", height: `${height}px` }} />;
}
